<template>
  <v-layout>
    <v-container grid-list-md>
      <v-card>
        <v-card-title primary-title>
          <h5 class="subheading mb-0">Settings</h5>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-card>
              <v-card-title>
                <h5>SMS Settings</h5>
              </v-card-title>
              <v-card-text>
                <v-form ref="form">
                  <v-layout row wrap>
                    <v-flex xs12>
                      <!-- <v-text-field
                      label="SMS Username"
                      v-model="sms_model.username"
                      :rules="valid_rules.required"
                      ></v-text-field>-->

                      <v-switch
                        label="Send thank you note after purchase"
                        v-model="sms_model.send_tyn"
                        :loading="loading"
                      ></v-switch>
                    </v-flex>
                    <!-- <v-text-field
                    label="SMS Password"
                    v-model="sms_model.password"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    :rules="valid_rules.required"
                    ></v-text-field>-->
                    <v-flex xs12>
                      <v-textarea
                        v-if="sms_model.send_tyn"
                        label="Enter thank you note:"
                        v-model="sms_model.tyn_msg"
                        outline
                        :rules="valid_rules.required"
                        counter
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-card-text>
            </v-card>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="saveSettings()" :loading="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
      <snackbar ref="sb"></snackbar>
    </v-container>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import snackbar from "../shared/snackbar";
export default {
  components: {
    snackbar
  },
  data() {
    return {
      show1: false,
      tn:"",
      sms_model: {
        send_tyn: false, //send thank you note
        tyn_msg: ""
      },
      // sms_modelcp: {
      //   username: "",
      //   password: ""
      // },
      valid_rules: {
        required: [v => !!v || "this field is required"]
      }
    };
  },
  methods: {
    saveSettings() {

      if(!this.$refs.form.validate()){
        return
      }
      var sb = this.$refs.sb;
      this.$store.dispatch("settings/add", this.sms_model);

      if (this.serrors == null) {
        this.snackbarconf(sb, "Settings saved successfully", "success");
        // this.sms_model = {
        //   send_tyn: false, //send thank you note
        //   tyn_msg: ""
        // };
      } else {
        this.snackbarncof(sb, "Sorry, settings could not be saved", "error");
      }
    },
    snackbarconf(snackbar, message, color) {
      snackbar.text = message;
      snackbar.color = color;
      snackbar.snackbar = true;
    }
  },
  mounted() {
    this.$store.dispatch("settings/getAll");
  },
  computed: {
    ...mapGetters({
      settings: "settings/SETTINGS",
      serrors: "settings/SETTING_ERROR",
      loading: "settings/SETTING_LOADING"
    })
  },
  watch: {
   
    settings(val) {
      if (this.serrors == null && this.settings.sms) {
        this.sms_model = JSON.parse(JSON.stringify(this.settings.sms));
      }
    }
  }
};
</script>